import { Record } from 'immutable';

export default class CoordinateRecord extends Record({
  lat: null,
  lng: null,
}) {
}
